import { decode, encode, isValid } from 'js-base64';
import { mapActions, mapGetters } from 'vuex';
import lodash from 'lodash';
import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  mixins: [dashboardPartnerData],
  computed: {
    redirectParams() {
      let retData = {};

      try {
        const decodedParams = decode(decodeURIComponent(this.authRedirectParams || ''));
        if (decodedParams) {
          retData = JSON.parse(decodedParams);
        }
      } catch (err) {
        this.handleError({ error: err, showModal: false, code: '0x00000040' });
      }

      if (this.$route.hash) {
        retData.hash = this.$route.hash;
      }

      return encodeURIComponent(encode(JSON.stringify(retData), true));
    },
    ...mapGetters({
      authRedirectParams: 'general/authRedirectParams'
    })
  },
  methods: {
    ...mapActions({
      updatePartner: 'profile/dashboard/updatePartner'
    }),

    // eslint-disable-next-line complexity
    async redirectAfterAuthorization(redirectDataEncoded) {
      let redirectPath;
      let defaultPath = 'dashboard';

      if (this.$auth.isLoggedIn) {
        defaultPath = 'dashboard';
      }

      if (this.$auth.isLoggedIn && this.$auth.user.benefit.partnerUrl) {
        await this.updatePartner({
          partnerUrl: this.$auth.user.benefit.partnerUrl,
          region: this.$domainRegion
        });
      }

      if ((this.$auth.isLoggedIn && !this.allowUser) || this.$auth.user?.isPasswordExpired) {
        defaultPath = 'dashboardLock';
      }

      try {
        let redirectParams = {
          name: defaultPath
        };

        if (redirectDataEncoded && redirectDataEncoded.length) {
          const decodedUriData = decodeURIComponent(redirectDataEncoded || '');
          if (isValid(decodedUriData)) {
            const redirectDataJson = decode(decodedUriData);

            if (redirectDataJson) {
              const redirectData = JSON.parse(redirectDataJson);
              redirectParams = {
                name: redirectData?.page || defaultPath,
                query: redirectData?.query || '',
                params: redirectData?.params || '',
                hash: redirectData.hash || ''
              };
            }

            redirectPath = this.$localePath(redirectParams);
          } else {
            const decodedUriDataUrl = new URL(decodedUriData);
            const oldWebUrl = new URL(import.meta.env.VITE_OLD_WEB_URL);
            const isConsultation =
              decodedUriDataUrl.hostname === oldWebUrl.hostname &&
              decodedUriDataUrl.pathname.includes('poradna-lekare');

            if ((isConsultation && this.$auth.user.language !== 'cs') || !isConsultation) {
              redirectPath = decodedUriData;
            } else {
              redirectParams = { name: defaultPath };

              if (isConsultation) {
                const pathParams = decodedUriDataUrl.pathname.split('/');
                const doctorAnswerPathParamsWords = pathParams[pathParams.length - 1].split('-');
                const doctorAnswerId =
                  doctorAnswerPathParamsWords[doctorAnswerPathParamsWords.length - 1];
                redirectParams = {
                  name: 'profileExploreDetail',
                  query: { id: doctorAnswerId },
                  params: { type: 'consultations' }
                };
              }

              redirectPath = this.$localePath(redirectParams);
            }
          }
        }
      } catch (err) {
        this.handleError({ error: err, showModal: false, code: '0x00000041' });
      }

      const redirect = lodash.isEmpty(redirectPath) ? this.$localePath(defaultPath) : redirectPath;

      if (this.isMobileApp) {
        if (typeof redirect === 'string' && /^[a-z][a-z0-9+.-]*:\/\//i.test(redirect)) {
          window.location.replace(redirect);
          return;
        }
        await this.$router.replace(redirect);
      } else if (
        this.$vuetify.breakpoint.smAndDown &&
        this.$route.query.deviceIdentifier === 'registration_app'
      ) {
        const currentAppUrl = this.$currentUrl.replace(
          /(https?)(:\/\/)(.*)/,
          `${import.meta.env.VITE_APP_LINK_SCHEME}$2$3`
        );
        const url = `${currentAppUrl}${redirect}`;
        window.location.replace(url);
      } else {
        await this.$router.push(redirect);
      }
    }
  }
};
